import { cva } from 'class-variance-authority';

export const badgeVariants = cva(
  'inline-flex h-5 shrink-0 items-center gap-1 whitespace-nowrap rounded-pill px-2 text-2xs font-medium [&_svg]:size-3 [&_svg]:shrink-0',
  {
    variants: {
      tone: {
        neutral: 'bg-surface-sunken text-ink-2',
        brand: 'bg-brand-subtle text-brand',
        success: 'bg-success-subtle text-success',
        warning: 'bg-warning-subtle text-warning',
        danger: 'bg-danger-subtle text-danger',
        /** For badges over photos ("360°", "Inicio"). Frosted in the new kit. */
        glass: 'bg-surface/80 text-ink',
      },
    },
    defaultVariants: { tone: 'neutral' },
  },
);
